import React from 'react';
import PropTypes from 'prop-types';
import PhotoForm from './photo_form';

export default function MediaPhotoForm({
  basePhotoFormProps,
  bulkDownloadPhotosLink,
  name,
  photos,
  photoEditorUrl,
  onPhotoChange,
  osSection,
  showEdit = true,
  showLimit = false,
  syndication
}) {

  return (
    <PhotoForm
      {...basePhotoFormProps}
      bulkDownloadPhotosLink={bulkDownloadPhotosLink}
      maxPhotos={100}
      name={name}
      osSection={osSection}
      photoAttachments={photos}
      photoEditorUrl={photoEditorUrl || basePhotoFormProps.photoEditorUrl}
      showEdit={showEdit}
      showLimit={showLimit}
      syndication={syndication}
      onPhotoChange={onPhotoChange}
    />
  );
}

MediaPhotoForm.propTypes = {
  basePhotoFormProps: PropTypes.object.isRequired,
  bulkDownloadPhotosLink: PropTypes.string,
  name: PropTypes.string.isRequired,
  osSection: PropTypes.func,
  photoEditorUrl: PropTypes.string,
  photos: PropTypes.array.isRequired,
  showEdit: PropTypes.bool,
  showLimit: PropTypes.bool,
  syndication: PropTypes.bool.isRequired,
  onPhotoChange: PropTypes.func
};
